module.exports = __webpack_public_path__ + "media/images/powerpoint/media/background-white-f3342e03c8c3b7d779b86220fde560c3.png";